import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-4a531206"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "main"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "content"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "春游计划！欢乐童行、带孩子寻找公园里的10种小惊喜——快乐遛宠，共享萌趣时光", -1));

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tags"
}, "亲子出行", -1));

const _hoisted_6 = {
  class: "info"
};
const _hoisted_7 = {
  class: "info-item"
};
const _hoisted_8 = ["src"];

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "info-name"
}, "活动主办", -1));

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "info-value"
}, "成都天府绿道", -1));

const _hoisted_11 = {
  class: "info-item"
};
const _hoisted_12 = ["src"];

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "info-name"
}, "活动时间", -1));

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "info-value"
}, "2025.03.22", -1));

const _hoisted_15 = {
  class: "info-item"
};
const _hoisted_16 = ["src"];

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "info-name"
}, "开展景区", -1));

const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "info-value"
}, "凤凰山公园", -1));

const _hoisted_19 = {
  class: "info-item"
};
const _hoisted_20 = ["src"];

const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "info-name"
}, "活动地点", -1));

const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "info-value"
}, "四川省成都市金牛区凤凰山公园", -1));

const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "desc"
}, "活动介绍", -1));

const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "word"
}, " 在草地上搭起帐篷，享受阳光与野餐的乐趣，和孩子一起观察自然、分享故事，创造温馨回忆。 ", -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
    class: "top-img",
    src: $setup.cyjh
  }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, [_hoisted_4, _hoisted_5, _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
    src: $setup.zbf,
    class: "icon"
  }, null, 8, _hoisted_8), _hoisted_9, _hoisted_10]), _createElementVNode("div", _hoisted_11, [_createElementVNode("img", {
    src: $setup.time,
    class: "icon"
  }, null, 8, _hoisted_12), _hoisted_13, _hoisted_14]), _createElementVNode("div", _hoisted_15, [_createElementVNode("img", {
    src: $setup.addr,
    class: "icon"
  }, null, 8, _hoisted_16), _hoisted_17, _hoisted_18]), _createElementVNode("div", _hoisted_19, [_createElementVNode("img", {
    src: $setup.loca,
    class: "icon"
  }, null, 8, _hoisted_20), _hoisted_21, _hoisted_22])]), _hoisted_23, _hoisted_24])]);
}